import React from 'react';
import {
  Box,
  Skeleton,
  Grid,
  Card,
  CardContent,
  Stack,
  Divider,
} from '@mui/material';

const DashboardSkeleton = () => {
  return (
    <Box sx={{ p: 3, backgroundColor: 'background.default', minHeight: '100vh' }}>
      {/* Header Skeleton */}
      <Box mb={4}>
        <Skeleton variant="text" width={300} height={60} />
        <Skeleton variant="text" width={400} height={30} />
      </Box>

      {/* Metrics Cards Skeleton */}
      <Grid container spacing={3} mb={4}>
        {[1, 2, 3, 4].map((item) => (
          <Grid item xs={12} sm={6} md={3} key={item}>
            <Card sx={{ height: '100%', borderRadius: 2, boxShadow: 3 }}>
              <CardContent>
                <Stack direction="row" justifyContent="space-between">
                  <Skeleton variant="circular" width={48} height={48} />
                  <Skeleton variant="circular" width={24} height={24} />
                </Stack>
                <Skeleton variant="text" width="60%" height={30} sx={{ mt: 1 }} />
                <Skeleton variant="text" width="40%" height={50} />
                <Skeleton variant="text" width="70%" height={20} sx={{ mt: 1 }} />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Charts Section Skeleton */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%', borderRadius: 2, boxShadow: 3 }}>
            <CardContent>
              <Stack direction="row" justifyContent="space-between" mb={2}>
                <Skeleton variant="text" width={200} height={40} />
                <Skeleton variant="circular" width={24} height={24} />
              </Stack>
              <Skeleton variant="rectangular" height={300} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%', borderRadius: 2, boxShadow: 3 }}>
            <CardContent>
              <Stack direction="row" justifyContent="space-between" mb={2}>
                <Skeleton variant="text" width={200} height={40} />
                <Skeleton variant="circular" width={24} height={24} />
              </Stack>
              <Skeleton variant="rectangular" height={300} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Recent Activity Skeleton */}
      <Card sx={{ mt: 4, borderRadius: 2, boxShadow: 3 }}>
        <CardContent>
          <Skeleton variant="text" width={200} height={40} />
          <Grid container spacing={2}>
            {[1, 2, 3].map((item) => (
              <Grid item xs={12} md={4} key={item}>
                <Box sx={{ p: 2, borderRadius: 2 }}>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Skeleton variant="circular" width={40} height={40} />
                    <Box sx={{ width: '100%' }}>
                      <Skeleton variant="text" width="80%" height={25} />
                      <Skeleton variant="text" width="60%" height={20} />
                    </Box>
                  </Stack>
                </Box>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default DashboardSkeleton;